import React, { useState } from "react";
import { Server } from "@modules/api";
import { Button } from "@ui/button";
import { MoreHorizontal } from "lucide-react";
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from "@ui/menubar";
import TranslatedText from "@components/items/display/TranslatedText";
import { removePlaylist, useAppDispatch } from "@lib/stores";
import {
  getPaginatedPlaylistsAsync,
  getPlaylistsAsync,
} from "@lib/stores/myLibrary/slices";
import EditPlaylistDialog from "./EditPlaylistDialog";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import { useSearchParams } from "react-router-dom";

const PAGE_SIZE = 5;

const PlaylistItemMenu = ({ item }: { item: Server.PlaylistOutput | null }) => {
  const navigate = useAppNavigate();
  const dispatch = useAppDispatch();

  const [searchParams] = useSearchParams();
  const currentPlaylistId = searchParams.get("id");

  const [isEditDialogOpen, setIsEditDialogOpen] = useState<boolean>(false);

  return (
    <>
      <EditPlaylistDialog
        id={item?.id ?? 0}
        defaultTitle={item?.title}
        isOpen={isEditDialogOpen}
        setOpen={setIsEditDialogOpen}
      />
      <Menubar className="border-none">
        <MenubarMenu>
          <MenubarTrigger
            asChild
            className="cursor-pointer rounded-none focus:bg-transparent focus-visible:ring-0 data-[state=open]:bg-transparent dark:text-white"
            onClick={(e) => e.stopPropagation()}
          >
            <Button variant="basic" className="gap-x-10">
              <MoreHorizontal size={25} />
            </Button>
          </MenubarTrigger>
          <MenubarContent
            align="start"
            className="text-[#898A8D] dark:border-none dark:bg-dark_background dark:text-white"
          >
            <MenubarItem
              inset={true}
              onClick={(e) => {
                e.stopPropagation();
                setIsEditDialogOpen(true);
              }}
              className="focus:bg-[#f8fafc] dark:focus:bg-[#0f172a]"
            >
              <TranslatedText text={`my-library.${"edit"}`} />
            </MenubarItem>
            <MenubarItem
              inset={true}
              className="text-red-500 focus:bg-[#f8fafc] focus:text-red-500 dark:focus:bg-[#0f172a]"
              onClick={(e) => {
                e.stopPropagation();
                removePlaylist(item?.id, () => {
                  if (currentPlaylistId) {
                    navigate("/");
                  }
                  dispatch(getPlaylistsAsync());
                  dispatch(
                    getPaginatedPlaylistsAsync({
                      PageNumber: 1,
                      PageSize: PAGE_SIZE,
                      SortBy: Server.SortBy.MostRecent,
                    })
                  );
                });
              }}
            >
              <TranslatedText text={`my-library.${"remove"}`} />
            </MenubarItem>
          </MenubarContent>
        </MenubarMenu>
      </Menubar>
    </>
  );
};

export default PlaylistItemMenu;
